module.exports = __webpack_public_path__ + "site/img/weibo.7d5e1ac.png";


//////////////////
// WEBPACK FOOTER
// ./site/weibo.png
// module id = 172
// module chunks = 1